import { Stack, useLocalSearchParams } from 'expo-router';
import { useQuery } from 'urql';
import ButtonToast, { useButtonToast } from '@/components/Custom/ButtonToast';
import ModalKeyboardAwareScrollView from '@/components/Custom/ModalKeyboardAwareScrollView';
import Placeholder from '@/components/Custom/Placeholder';
import MemberAddInvite from '@/components/MemberAdd/MemberAddInvite';
import ContentBoundary from '@/components/UI/ContentBoundary';
import Box from '@/components/Unistyles/Box';
import { graphql } from '@/gql/graphql';

const GetOrganizationPersonAdd = graphql(/* GraphQL */ `
  query GetOrganizationPersonAdd($organizationId: uuid!) {
    event_by_pk(id: $organizationId) {
      id
      title
    }
  }
`);

export default function OrganizationPersonAdd() {
  const { organizationId } = useLocalSearchParams<{
    organizationId: string;
  }>();
  const [toast, setToast] = useButtonToast();
  const [{ data, error, fetching }, retry] = useQuery({
    query: GetOrganizationPersonAdd,
    variables: { organizationId },
    pause: !organizationId,
  });
  const organization = data?.event_by_pk;
  const onRetry = () => retry({ requestPolicy: 'network-only' });
  return (
    <Box flex>
      <Stack.Screen
        options={{
          title: organization
            ? `Add People to ${organization.title ?? 'Organization'}`
            : 'Add People',
        }}
      />
      <ContentBoundary
        data={organization}
        loading={fetching}
        error={error}
        errorMessage="Could not load organization."
        onRetry={onRetry}
        empty={
          <Placeholder
            icon="refresh-outline"
            text="Organization Not Found"
            subText="Tap to try again."
            onPress={onRetry}
          />
        }
      >
        {(organization) => (
          <ModalKeyboardAwareScrollView>
            <MemberAddInvite
              entity={{
                id: organization.id,
                kind: 'organization',
                title: organization.title ?? 'Organization',
              }}
              initialMemberType="non_participant"
              setToast={setToast}
            />
          </ModalKeyboardAwareScrollView>
        )}
      </ContentBoundary>
      <ButtonToast {...toast} />
    </Box>
  );
}
